var exports = {
  "J0": "branches__3hqMzX",
  "Dw": "baseBranchGroup__CJSpgC",
  "i_": "baseBranchGroupCompact__U6vXqn",
  "wi": "headBranchGroup__ELi8vG",
  "XU": "headBranchGroupCompact__6BxJpG",
  "y8": "leadingSeparator__ggenRP",
};

module.exports = exports;
